import { createFileRoute } from '@tanstack/react-router'

import { MembershipApplicationsPage } from '@/features/membership/applications'

export const Route = createFileRoute('/_authenticated/membership/applications')({
  component: MembershipApplicationsPage,
})

